module.exports = __webpack_public_path__ + "img/ecuador-logo-icon.b5d425e5.png";